import { render, staticRenderFns } from "./index4.vue?vue&type=template&id=ab0a59c8&scoped=true&"
import script from "./index4.vue?vue&type=script&lang=js&"
export * from "./index4.vue?vue&type=script&lang=js&"
import style0 from "./index4.vue?vue&type=style&index=0&id=ab0a59c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0a59c8",
  null
  
)

export default component.exports